// |-- Built-in Dependencies --|
import React  from "react";

// |-- External Dependencies --|
import { BiSearchAlt2 } from "react-icons/bi";
import { IconType } from "react-icons";

// |-- Internal Dependencies --|
import ATMInputAdormant from "src/components/UI/atoms/formFields/ATMInputAdormant/ATMInputAdormant";
import { Tooltip } from "@mui/material";

// |-- Types --|
type ViewLayoutPropTypes = {
  leftbar?: boolean;
  planId?:string ;
  infoCard?: React.ReactNode;
  actionIcons?: {
    icon: IconType;
    onClick: () => void;
  }[];
  listData?: any[];
  tabs?: {
    label: string;
    icon: IconType;
    path: string;
  }[];
  searchValue?: string;
  onSearch?: (value: string) => void;
  onClickViewMore?: () => void;
  onClickChangeRequestView?: (TICKET_ID: string) => void;
  hideViewMore?: boolean;
  children?: any;
};


const DayPlanningLayout = ({
  leftbar = true,
  planId,
  infoCard,
  listData,
  tabs,
  searchValue = "",
  onSearch = () => {},
  onClickChangeRequestView = () => {},
  onClickViewMore,
  hideViewMore = false,
  children,
}: ViewLayoutPropTypes) => {
  // const navigate = useNavigate()


  return (
    <>
      <div className="h-[calc(100vh-50px)] border-r mt-2">
        <div className="  h-[calc(100%)] bg-white">
          {/* Left Section Side Bar */}
          <div className="md:block hidden">
          {leftbar === true && (
            <div className=" h-full flex flex-col">

              {/* Search Bar */}

              <div className="px-2 py-2 flex items-center justify-center ">
                <ATMInputAdormant
                  name=""
                  value={searchValue}
                  placeholder="Search here..."
                  className="h-[40px] shadow-sm border-[1px] focus:border-black"
                  adormant={
                    <BiSearchAlt2 className="text-slate-400 text-xl " />
                  }
                  adormantProps={{
                    position: "start",
                    extraClasses: "bg-white border-0 ",
                  }}
                  onChange={(e) => {
                    onSearch(e.target.value);
                  }}
                />
               
              </div>

              {/* List */}
              <div className="grow overflow-auto">
                <div className="px-[8px] flex flex-col min-w-[100%] overflow-y-auto">
                  {listData?.length ? listData?.map((ele: any) => {
                    return (
                      <div
                        key={ele?._id}
                        className={`shadow-sm mb-2 border-[1px] border-slate-100 rounded cursor-pointer relative ${
                          ele?._id === planId ? "bg-blue-300 text-white font-medium" : "bg-white"
                        }`}
                        onClick={() => onClickChangeRequestView(ele?._id)}
                      >
                        <div className="flex gap-x-2 py-2 px-2">
                          <div className="bg-[#ebebeb] text-xs rounded-md px-1 py-[1px]">
                            <div className="text-xs text-black">
                              {ele?.noOfDays} Days
                            </div>
                          </div>
                        </div>

                        <div className="p-1" style={{ userSelect: "text" }}>
                          <Tooltip title={ele?.planName}>
                            <h3 className="w-full overflow-hidden truncate text-md min-w-[100%] hover:underline font-medium">
                              {ele?.planName}
                            </h3>
                          </Tooltip>

                        </div>
                      </div>
                    );
                  }) : <div className="flex justify-center items-center text-red-600 font-medium">No Data Found</div>}
                  {/* View more button */}
                  {hideViewMore && (
                    <span
                      onClick={onClickViewMore}
                      className="text-black text-center text-sm cursor-pointer hover:underline select-none"
                    >
                      View More
                    </span>
                  )}
                </div>
              </div>
            </div>
          )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DayPlanningLayout;